module.exports = __webpack_public_path__ + "img/member-icon-1.0ad35522.png";